import './Loader.css';

export default function Loader() {
    return (
        <div className='flex overflow-hidden transform w-screen h-screen justify-center items-center bg-[#F4F9FA]'>
            <img className='rotate' src='/assets/svg/loader.svg' alt='loader'/>
        </div>
    )
}